// extracted by mini-css-extract-plugin
module.exports = {"page":"JudgeList_page__3qZWm","mainTable":"JudgeList_mainTable__SOxzq"};